///
/// EarthBrowser
///
/// Buoy Browser Feature
///
/// Manages buoy browser window lifecycle and command palette registration
///
/// Created by Matt Giger on December 21, 2025
/// Copyright (c) 2025 Geodata Labs
///

import { useEffect } from 'react'
import { Anchor } from 'lucide-react'
import { BuoyBrowserRenderer } from '@/components/features/buoy-browser/BuoyBrowser'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const BUOY_WINDOW_ID = 'buoy-browser'
const BUOY_WINDOW_WIDTH = 800
const BUOY_WINDOW_HEIGHT = 600

export function BuoyBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const buoyWindow = datasetWindows[BUOY_WINDOW_ID]

	// Register with command palette
	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'buoy-browser',
			command: {
				id: 'buoys',
				title: 'Buoys & Coastal Stations',
				icon: <Anchor className="w-4 h-4 text-cyan-500" />,
				category: 'Datasets',
				enabled: true,
				onSelect: () => {
					openOrRestoreWindow(
						dispatch,
						datasetWindows,
						BUOY_WINDOW_ID,
						{
							id: BUOY_WINDOW_ID,
							title: 'Buoys & Coastal Stations',
							windowType: 'buoy',
							x: 140,
							y: 140,
							width: BUOY_WINDOW_WIDTH,
							height: BUOY_WINDOW_HEIGHT,
							isMaximized: false,
							isVisible: true,
						}
					)
				}
			},
			renderBrowser: () => null // Not needed for window-based browser
		})

		return unregister
	}, [dispatch, datasetWindows])

	// Render the window if it's open
	if (!buoyWindow) {
		return null
	}

	return (
		<BuoyBrowserRenderer
			windowId={BUOY_WINDOW_ID}
			windowState={buoyWindow}
		/>
	)
}

